import { authFetch } from "../../api";

export const getProgramList = async (requestData) => {
  try {
    const response = await authFetch(`packages/show-programs`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch programs");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch programs:", err.message);
  }
};

export const getPackagesList = async ({ requestData, perPage = 3 }) => {
  try {
    const response = await authFetch(
      `packages/show-packages?per_page=${perPage}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch packages");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch packages:", err.message);
  }
};

export const getAllPackagesList = async ({
  user_id,
  page = 1,
  perPage = 3,
}) => {
  try {
    const response = await authFetch(
      `packages/show-all-packages?page=${page}&per_page=${perPage}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id, // required by API
        }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch packages");
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Failed to fetch packages:", err.message);
  }
};
